import WarningIcon from '@mui/icons-material/Warning';
import React, { useState } from 'react';

// Components
import KOGCollapse from '@/main/components/shared/kogCollapse/kogCollapse';
import KOGImage from '@/main/components/shared/kogImage/kogImage';
import QuoteProcurementPartInfo, { getTooltipFormatted } from '@/main/components/shared/quoteProcurementPartInfo/quoteProcurementPartInfo';
import { SpinnerLoading } from '@/main/components/shared/styles';

// Utils
import { IMAGE_DEFAULT } from '@/main/services/constants';
import { getTranslateByKey, isNullUndefined, isShowControlByElementId } from '@/main/services/utils';

// Models
import { quoteApi } from '@/main/api';
import {
  QuoteNoSupplierAssignedItemResponse,
  QuoteNoSupplierAssignedResponse,
  QuoteSelectSuppliersDataResponseItems
} from '@/main/models/response';
import { Controls } from '@/main/services/constants/constantsControl';
import { formatCurrency } from '@/main/services/utilsNumber';

// Styles/Components Local
import ButtonRequotePart from './components/buttonRequotePart';
import * as S from './styles';
import { AddCartType, RefreshQuoteByGetItemsType } from './components/types';
import { ProcurementStatusEnum } from '@/main/services/enum/StatusProcurement';
import { CartState } from '@/main/store/cart';

interface DetailsCartSupplierCanceledUnansweredProps {
  cart: QuoteNoSupplierAssignedResponse | null;
  part: QuoteNoSupplierAssignedItemResponse;
  loadCart: (guidQuote: string) => void;
  idProcurementStatus: number;
  integration: boolean;
  guidQuote: string;
  showButtonRequoteBulkPart: boolean;
  isQuoteBlocked: boolean;
  isPaymentPending: boolean;
  dataCart: CartState;
  addCart: AddCartType;
  refreshQuoteByGetItems: RefreshQuoteByGetItemsType;
}
function DetailsCartSupplierCanceledUnanswered({
  cart: cartProps,
  part,
  addCart,
  dataCart,
  guidQuote,
  isQuoteBlocked,
  integration,
  idProcurementStatus,
  isPaymentPending,
  showButtonRequoteBulkPart,
  refreshQuoteByGetItems
}: DetailsCartSupplierCanceledUnansweredProps) {
  const cart = cartProps as QuoteNoSupplierAssignedResponse;
  const showPrices = isShowControlByElementId(Controls.IdShowPrices);

  const showButtonRequotePart = () => showButtonRequoteBulkPart;
  const isQuoteCanceled = idProcurementStatus === ProcurementStatusEnum.Cancelled;


  return (
    <S.ContainerPartNoCollpase>
      <S.WrapperHeaderNoCollpase>
      <S.BodyBox key={part.guidQuoteItem} style={{ position: 'initial' }}>
        <S.ContainerPart>
          <KOGImage width={80} height={80} src={IMAGE_DEFAULT} />
          <S.PartInfo
            title={getTooltipFormatted(part.quoteProcurementPartInfo)}>
            <QuoteProcurementPartInfo
              data={part.quoteProcurementPartInfo}
              renderType="column"
              showIconNotes
            />
          </S.PartInfo>
          {(showPrices && !isNullUndefined(part.priceCap)) && (
            <S.TextPriceCap>
              {`${getTranslateByKey('information.priceCap')}: ${formatCurrency(part.priceCap)}`}
            </S.TextPriceCap>
          )}
        </S.ContainerPart>
        <S.AreaButtonAbsolute>
          {showButtonRequotePart() && (
            <ButtonRequotePart
              type='unaswered'
              dataCart={dataCart}
              refreshQuoteByGetItems={refreshQuoteByGetItems}
              isQuoteBlocked={isQuoteBlocked}
              isQuoteCanceled={isQuoteCanceled}
              isRequotePartCanceled={true}
              part={{
                guidQuoteItem: part.guidQuoteItem,
                idPartType: part.idPartType,
                replacePartType: false
              }}
              idButtonRequotePart={`id-createOrder-button-requoteProduct-${cart.showDeadlineAnswer}`}
            />
          )}
        </S.AreaButtonAbsolute>
      </S.BodyBox>
      </S.WrapperHeaderNoCollpase>
    </S.ContainerPartNoCollpase>
  )
}

interface BoxCartUnansweredCanceledItemsProps extends Omit<DetailsCartSupplierCanceledUnansweredProps, 'showButtonRemoveBulkPart' | 'part'> {
}
function BoxCartUnansweredCanceledItems(props: BoxCartUnansweredCanceledItemsProps) {
  if (isNullUndefined(props.cart) || props.cart.parts == null || props.cart.parts.length === 0) return null

  return (
    <S.ContainerBox>
      <S.HeaderBox>
        <S.ContainerTitleBox>
          <S.TitleBox>
             {getTranslateByKey("information.cancelledparts")}
          </S.TitleBox>
        </S.ContainerTitleBox>
      </S.HeaderBox>
      <S.ContentBox>
        {props.cart.parts.map(
          (part, index) => (
            <DetailsCartSupplierCanceledUnanswered
              key={part.guidQuoteItem}
              {...props}
              part={part}
            />
          )
        )}
      </S.ContentBox>
    </S.ContainerBox>
  );
}

export default BoxCartUnansweredCanceledItems;
